import { FC } from "react";
import moment from "moment";
import NewsByIdAnalyst from "./NewsByIdAnalyst";
import NewsByIdIcon from "./NewsByIdIcon";
import Quill from "../../../../components/common/quill/Quill";
import NewsList from "../../../../components/news/NewsList";
import { useAppDispatch } from "../../../../hooks/redux-hooks";
import { setYoutubeUrlState } from "../../../../store/slices/news";
import BigPlay from "../../../../assets/icon/BigPlay";

interface Props {
  icon: string;
  title: string;
  date?: string;
  views?: string;
  description: string;
  youtubeUrl?: string;
}

const NewsByCard: FC<Props> = ({
  icon,
  description,
  title,
  date,
  views,
  youtubeUrl,
}) => {
  const createDate = moment(date).format("DD.MM.YYYY");
  const dispatch = useAppDispatch();

  const handeleClick = (link: string) => {
    dispatch(setYoutubeUrlState(link));
  };

  return (
    <>
      <div>
        <div className="md:flex md:justify-end md:flex-row-reverse md:items-center md:pt-10">
          <div className="w-full md:pl-8">
            <h1 className="py-5 text-2xl font-semibold">{title}</h1>
            <div className="flex items-center text-sm pb-5 md:pb-4 md:hidden">
              {views && (
                <NewsByIdAnalyst publicationDate={createDate} views={views} />
              )}
            </div>
            <div className="hidden md:flex md:items-center md:text-sm md:pb-4">
              {views && (
                <NewsByIdAnalyst publicationDate={createDate} views={views} />
              )}
            </div>
          </div>
          <div className="flex justify-center md:justify-start">
            <div
              className={`max-w-[22.5rem] min-w-[22.5rem] max-h-[12.687rem] min-h-[12.687rem] overflow-hidden rounded-md ${
                youtubeUrl && "relative"
              }`}
            >
              <NewsByIdIcon icon={icon} />
              <div
                onClick={() => {
                  if (youtubeUrl) {
                    handeleClick(youtubeUrl);
                  }
                }}
                className={`${
                  youtubeUrl &&
                  "absolute left-[42%] top-[36%] z-20 cursor-pointer opacity-90 rounded-full hover:border hover:border-orange_hover hover:rounded-full hover:opacity-100 hover:transition-opacity"
                }`}
              >
                <BigPlay />
              </div>
              <div
                className={`${
                  youtubeUrl &&
                  "absolute top-0 left-0 w-full h-full z-10 bg-black opacity-40"
                }`}
              ></div>
            </div>
          </div>
        </div>
        <p className="py-5">
          <Quill text={description} className={"news"} />
        </p>

        <div className="w-full pt-14 md:flex md:justify-between md:flex-wrap">
          <p className="text-xl font-bold">Інші новини</p>
          <NewsList />
        </div>
      </div>
    </>
  );
};

export default NewsByCard;
